<template>
    <div class="basic-modal px-3">
        <!-- <div v-if="type == 'linkList'" class="d-flex flex-row justify-content-center align-items-center">
            <div v-for="val in value" :key="val"><a href="#">{{val}}</a></div>
        </div> -->
        <div class="d-flex flex-row justify-content-center" style="overflow: auto; max-height: 500px;">
            <ul style="list-style-type: none; padding: 0;">
                <li style="margin: 10px 0;" v-for="val in value" :key="val.id">
                    <a href="#" @click.prevent="goToPage(val.url)">{{val.text}}</a>
                </li>
            </ul>
        </div>
    </div>
</template>
    
<script>
let config = { 
    linkList: { 
        title: "View All",
        buttons: "Close",
    },
}

export default {
  props: ["type", "initialValue"],
  inject: ['closeModal'],
  data() {
    return {
        value: this.initialValue,
    };
  },
  computed: {
      title() { return config[this.type].title; },
      buttons() { return config[this.type].buttons; },
      height() { return 200; },
  },
  methods: {
    async ok() {
        return true;
    },
    goToPage(url) {
        console.log("BasicModal goToPage url: ", url);
        this.closeModal(url);
    }
  },
};

</script>

<style lang="scss" scoped>
    .basic-modal {
        font-size: 108%;
    }
</style>



// WEBPACK FOOTER //
// src/framework/primitives/ListModal.vue